import React, { useState, useEffect } from "react";
import "../App.css";

const NetworkStatus: React.FC = () => {
  const [showOfflineAlert, setShowOfflineAlert] = useState(!navigator.onLine);

  useEffect(() => {
    const handleOnline = () => {
      setShowOfflineAlert(false);
      // Body Padding entfernen wenn online
      document.body.classList.remove("content-with-offline-bar");
    };

    const handleOffline = () => {
      setShowOfflineAlert(true);
      // Body Padding hinzufügen wenn offline
      document.body.classList.add("content-with-offline-bar");
    };

    // Initial check und Body-Klasse setzen
    if (!navigator.onLine) {
      document.body.classList.add("content-with-offline-bar");
    }

    // Event Listener für Netzwerkstatus
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
      // Cleanup: Body-Klasse entfernen
      document.body.classList.remove("content-with-offline-bar");
    };
  }, []);

  if (!showOfflineAlert) {
    return null;
  }

  return (
    <div className="offline-status">
      📡 App ist offline - Einige Funktionen sind möglicherweise nicht verfügbar
    </div>
  );
};

export default NetworkStatus;
